// extracted by mini-css-extract-plugin
export default {"planets":"bd-I-","planet1":"vjvdX","planet2":"iPk-F","planet3":"KqD1a","planet4":"Uv5Xt","planet5":"YucS-","skeleton-progress":"oP01B"};